import api from "@/api";
const state = {
  list: { data: [], paging: {} }
};
const getters = {
  list: state => {
    return state.list;
  },
  glossary: state => {
    return state.list.data;
  },
  local() {
    return process.env.VUE_APP_LOCAL_CURRENCY_ID;
  },
  foreign() {
    return process.env.VUE_APP_FOREIGN_CURRENCY_ID;
  }
};
const actions = {
  async getList({ commit }, params) {
    const result = await api.get("/api/v1/suppliers/view_currency/", params);
    if (result && result.status == 200) {
      commit("setList", result.data);
      return result;
    }
    return null;
  }
};
const mutations = {
  setList: (state, payload) => {
    state.list = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
